<template>
  <div>
    <div class='row align-items-center mb-ten'>
      <div class='col'>
        <ic-tab
            outlined
            @change='tabChange'
            :items="tabItems"
        />
      </div>
      <a @click.stop='modalHandler' class='icon-btn close-btn mr-row'>
        <i class='sr sr-close'></i>
      </a>
    </div>
    <template v-if='tabKey === "bank"'>
      <div>
        <!-- <table class='ic-table md mb-ten'>
          <tbody>
          <tr>
            <td>{{ $t('account.bankName') }}</td>
            <td>
              <select class='form-control' v-model='bankSelector'>
                <option value='05'>{{ $t('account.bankKhan') }}</option>
              </select>
            </td>
          </tr>
          <tr>
            <td>
              {{ $t('account.accountNumber') }}
            </td>
            <td class='d-flex justify-content-between align-items-center'>
              {{ accounts[bankSelector] }}
              <copy-button class='ml-1' :value='accounts[bankSelector]'/>
            </td>
          </tr>
          <tr>
            <td>
              {{ $t('account.accountName') }}
            </td>
            <td class='d-flex justify-content-between align-items-center'>
              {{ $t('account.brokerName') }}
              <copy-button class='ml-1' :value="$t('account.brokerName')"/>
            </td>
          </tr>
          <tr v-if="typeof user !== 'undefined' && user">
            <td>{{ $t('account.info') }}</td>
            <td class='d-flex justify-content-between align-items-center'>
              {{ description }}
              <copy-button class='ml-1' :value='description'/>
            </td>
          </tr>
          </tbody>
        </table> -->
        <p class='body-2 font-500'>{{ $t('account.description') }}</p>
      </div>
    </template>
    <template v-else-if='tabKey === "nominal"'>
      <b-form @submit.prevent='nominalRequest' class='py-3'>
        <b-form-group style='color: var(--text-primary-color)' :label="$t('cashout.amount')">
          <ic-input size='sm' disabled currency :precision="0" suffix="₮" v-model='requestModel.amount'/>
          <app-input :focused="true" disabled :label="'Гүйлгээний утга'" placeholder="Гүйлгээний утга" prefix="" :value="description"/>
          <div class='error-message' v-show='nominal.error'>
            <div>{{ errorMessage ? errorMessage : 'Хүсэлт илгээх үед алдаа гарлаа' }}</div>
          </div>
        </b-form-group>
        <div class='d-flex justify-content-center'>
          <ic-button size="tn">
            Эрх нээлгэх
          </ic-button>
        </div>
      </b-form>
    </template>
  </div>
</template>

<style scoped lang="scss">
button {
  background: #0C293A !important;
}
.amountInfo {
  background-color: var(--input-bg-color);
}
</style>

<script>
import CopyButton from '../global/CopyButton/index.vue'
import {mapState} from 'vuex'
import {required} from '@vuelidate/validators'
import {unformat} from '../../plugins/currency-input/utils'
import useVuelidate from '@vuelidate/core'
import VueQr from 'vue-qr'
import WarningInfo from "../WarningInfo.vue";
import {sendPaymentRequestNominal} from "../../api/user";
import Alert from "../Alert.vue";

export default {
  props: {
    requestModel: {
      type: Object,
      default: 0
    },
    code: {
      type: String,
      required
    }
  },
  setup() {
    return {v$: useVuelidate()}
  },
  data() {
    return {
      bankSelector: '05',
      accounts: {
        '05': 'MN440005005038170484',
      },
      // requestModel: {
      //   amount: 0,
      // },
      tabKey: 'bank',
      // resultSuccess: false
    }
  },
  components: {
    Alert,
    WarningInfo,
    CopyButton,
    VueQr,
  },
  computed: {
    ...mapState('common', ['dark']),
    ...mapState('user', ['user']),
    ...mapState('cashin', ['qpay', 'socialpay', 'nominal']),
    localBalance() {
      return this.$store.getters.localBalance
    },
    tabItems() {
      const items = []
      // bank таб үргэлж байна
      items.push({
        key: 'bank',
        text: this.$t('cashin.bank')
      })
      // Хэрэв tdb_account_number байвал nominal таб нэмнэ
      if (this.user?.tdb_account_number) {
        items.push({
          key: 'nominal',
          text: this.$t('cashin.nominal')
        })
      }
      return items
    },
    errorMessage() {
      if (this.tabKey === 'nominal') {
        if(this.localBalance.availableBalance < this.requestModel.amount) {
          return 'Дансны үлдэгдэл хүрэхгүй байна'
        }
        if (this.nominal.error && this.nominal.error.response && this.nominal.error.response.data)
          return this.nominal.error.response.data.message
      }

    },
    contracts() {
      return this.$store.getters['user/contracts']
    },
    main() {
      return this.contracts.find(contract => contract.type === 'main')
    },
    warningInfo() {
      return 'Харилцагч Та "Брокерийн үйлчилгээний гэрээ"-гээ байгуулна уу.'
    },
    description(){
      return this.user.register_number + ' ' + this.code
    },
    text() {
      if (this.code === 'FEE1') return 'Данс нээх дүн'
      if (this.code === 'FEE2') return 'Арилжааны эрх сунгах дүн'
      if (this.code === 'FEE3') return 'Данс нээх болон арилжааны эрх сунгах дүн'
    }
  },
  methods: {
    modalHandler() {
      // this.requestModel.amount = 5000
      this.$store.dispatch('cashin/clearValues')
      this.$store.dispatch('user/fetchUser')
      this.$emit('closeCashInModal')
    },
    tabChange(key) {
      this.tabKey = key
      this.$store.dispatch('cashin/clearValues')
    },
    async nominalRequest() {
      const amount = unformat(this.requestModel.amount, 0)
      this.$store.dispatch(
          'cashin/createNominalReq',
          {
            'amount': amount,
            'code': this.code
          }
      ).then(response => {
        console.log('createNominalReq ended:');
        if(!this.nominal.error) {
          this.$store.dispatch('user/fetchUser')
          this.$emit('showSuccessAlert')
        }
      }).catch(error => {
        // Алдааны үед хийх үйлдэл
        console.error('Error:', error);
      });
    },
  },
}

</script>
